import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticleGuide from "../pages/article/cssbuy-spreadsheet-guide/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/article/cssbuy-spreadsheet-guide",
    element: <ArticleGuide />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;